<template>
  <div class="chat-container">
    <div class="chat-header">小码AI 聊天助手</div>
    <div class="chat-body" ref="chatBody">
      <!-- 遍历消息列表，渲染每条消息 -->
      <div v-for="(msg, index) in messages" :key="index" :class="['message', msg.sender]">
        <!-- 用户消息（右对齐） -->
        <div v-if="msg.sender === 'me'" class="me">
          <div class="bubble">{{ msg.content }}</div>
          <div class="sender-name"><img src="../assets/user.png" alt=""></div>
        </div>

        <!-- AI 消息（左对齐） -->
        <div v-if="msg.sender === 'ai'" class="ai">
          <div class="sender-name"><img src="../assets/logo.png" alt=""></div>
          <div class="bubble" v-html="msg.content" >
          </div>
        </div>
      </div>
    </div>

    <div class="chat-input">
      <textarea v-model="userMessage" placeholder="请输入你的消息..." rows="1"></textarea>
      <button @click="isSending ? stopResponse() : sendMessage()">{{ isSending ? "停止" : "发送" }}</button>
    </div>
  </div>
</template>
<script>
import { marked } from 'marked';

export default {
  data() {
    return {
      userMessage: "",
      gptResponse: "",     // 临时存储 AI 回复
      messages: [{ sender: "ai", content: "oi 小鬼" },{ sender: "ai", content: "有什么可以帮忙的？" },], // 存储所有消息的数组
      isSending: false ,      // 控制发送按钮状态
      controller: null         // 控制器用于中止请求
    };
  },
  methods: {
    async sendMessage() {
        if (this.userMessage.trim() === "") {
        alert("请输入消息！");
        return;
      }
    
      this.isSending = true;  // 禁用发送按钮
      this.controller = new AbortController();    // 创建控制器
      
      // 追加用户消息
      this.messages.push({ sender: "me", content: this.userMessage });
   
      const messageToSend =this.messages.map(msg => ({ role: msg.sender === 'me' ? 'user' : 'assistant', content: msg.content }))
      this.userMessage = "";  // 清空输入框
      this.messages.push({ sender: "ai", content: "思考中..." });

      await this.sendMessageToGPT(messageToSend);  // 发送消息给 GPT
      this.scrollToBottom();                       // 滚动到底部
    },

    async sendMessageToGPT(message) {
      const options = {
        method: "POST",
        headers: {
          Authorization:
            "Bearer sk-hhhecygxhbsrbtxdfvtzgbobmmrxgzxwwhwntngboykubdyb", // 替换为你的 token
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          model: "deepseek-ai/DeepSeek-V3",
          // messages: [{ role: "user", content: message }],
          response_format: {"type": "text"} ,
          messages:message,
          stream: true,
          max_tokens: 1200,
          temperature: 0.7,
          top_p: 0.7,
          top_k: 50,
          frequency_penalty: 0.5,
          n: 1,
        }),
        signal: this.controller.signal, // 绑定中止信号
      };

      try {
        const response = await fetch(
          "https://api.siliconflow.cn/v1/chat/completions",
          options
        );

        if (!response.body) {
          console.error("未获取到有效的流数据");
          this.messages.push({ sender: "ai", content: "未收到有效回复。" });
          return;
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let aiReply = "";  // 临时存储 AI 回复
        let tru = false

        while (!tru) {
          const { done, value } = await reader.read();
          if (done) break;

          const chunk = decoder.decode(value);
          console.log("接收数据块:", chunk);

          const lines = chunk.split("\n").filter((line) => line.trim() !== "");
          for (const line of lines) {
            if (line.startsWith("data:")) {
              const jsonString = line.replace(/^data:\s*/, "");

              if (jsonString === "[DONE]") {
                console.log("数据流已完成");
                    // 确保每次更新 DOM 后才继续
              this.$nextTick(() => {
                this.scrollToBottom(); // 滚动到底部
              });
                this.isSending = false; // 启用发送按钮
                continue; // 跳过解析
              }
              try {
                const json = JSON.parse(jsonString);
                console.log("解析成功:", json);
  // 获取 reasoning_content，并实时更新页面
            if (json.choices && json.choices[0].delta.content) {
              const content = json.choices[0].delta.content;

              aiReply += content;  // 累加内容
 // 解析 Markdown 内容
 const markdownContent = marked(aiReply);
              // 更新消息列表中最后一条 AI 消息的内容
              if (this.messages.length > 0 && this.messages[this.messages.length - 1].sender === "ai") {
                this.messages[this.messages.length - 1].content = markdownContent;
              }

          

                }
              } catch (error) {
                console.error("解析数据块失败:", error);
              }
            }
          }
        }

  } catch (error) {
    if (error.name === "AbortError") {
      console.log("请求已终止");
      this.messages.push({ sender: "ai", content: "请求已被手动终止。" });
    } else {
      console.error("请求出错:", error);
      this.messages.push({ sender: "ai", content: "请求失败，请稍后再试。" });
    }
    this.isSending = false;
  }
    },
    // 滚动到底部
    scrollToBottom() {
      this.$nextTick(() => {
        const chatBody = this.$refs.chatBody;
        if (chatBody) {
          chatBody.scrollTop = chatBody.scrollHeight;
        }
      });
    },
    stopResponse() {
      this.isSending = false;   // 恢复发送按钮

      if (this.controller) {
        this.controller.abort();  // 中止请求
      }
      this.isSending = false;   // 恢复发送按钮
    },
  },
};
</script>

<style scoped>
/* 聊天容器 */
.chat-container {
  display: flex;
  flex-direction: column;
  height: 80vh;
  background-color: #f5f5f5;
  font-family: "Microsoft YaHei", sans-serif;
}

/* 头部标题 */
.chat-header {
  background-color: #4caf50;
  color: white;
  text-align: center;
  padding: 2vw;
  font-size: 4vw;
  font-weight: bold;
  position: sticky;
  top: 0;
  z-index: 10;
  margin-bottom: 4vw;
}

/* 聊天主体 */
.chat-body {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.message {
  display: flex;
  max-width: 98%;

}

.sender-name {
  max-width: 75%;
}
.sender-name img{
  width: 10vw;
}
.me {
  max-width: 98%;
  display: flex;
  justify-content: right;

}

.ai {
  max-width: 98%;
  display: flex;
  justify-content: left;
}

.bubble {
  border-radius: 15px;
  margin: 2vw;
  margin-top: 0;
  width: 80%;
  padding: 2.6vw;
  font-size: 4.3vw;
  background-color: #95ec69;
}


/* 输入框 */
.chat-input {
  display: flex;
  padding: 10px;
  background-color: white;
  border-top: 1px solid #ddd;
  position: sticky;
  bottom: 0;
  z-index: 10;

}

.chat-input textarea {
  flex: 1;
  resize: none;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 20px;
  /* outline: none; */
  margin-right: 10px;
  font-size: 4.6vw; /* 字体大小使用vw */
  /* overflow-y: auto; */
}
.chat-input textarea::placeholder {
  font-size: 4.6vw; /* 字体大小使用vw */
}
.chat-input button {
  background-color: #4caf50;
  color: white;
  border: none;
  padding: 8px 5vw;
  border-radius: 20px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.chat-input button:hover {
  background-color: #45a049;
}

/* 代码块样式 */
.bubble /deep/ pre {
  background-color: #454545; /* 深色背景 */
  color: #f8f8f2;           /* 代码文字颜色 */
  padding: 10px;
  border-radius: 8px;
  overflow-x: auto;          /* 水平滚动 */
  font-family: "Courier New", monospace;
  font-size: 3.2vw;          /* 自适应字体 */
  line-height: 4vw;
  white-space: pre;  
          /* 保留空格和换行 */
       /* 限制宽度 */
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);  /* 内阴影效果 */
}

/* 代码内联样式 */
.bubble /deep/ code {
  padding: 2px 4px;
  border-radius: 4px;
  font-family: "Courier New", monospace;
}


</style>